import { useRequestContext } from '@coolblue-development/next-request-context/client';

export default function useTestId(id: string) {
  const { isInternalUser } = useRequestContext();

  return {
    'data-cy': isInternalUser ? id : undefined,
    'data-testid': isInternalUser ? id : undefined
  };
}
